module.exports = __webpack_public_path__ + "img/q1.5043e6ba.png";